/**
 * Normalize stored field values to plain text (strip HTML / ProseMirror export noise).
 */

const HTML_TAG_RE = /<[a-z][\s\S]*>/i

const ENTITY_MAP = {
  '&nbsp;': ' ',
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
}

export function stripHtmlToPlainText(raw) {
  if (raw == null) return ''
  if (typeof raw !== 'string') return String(raw).trim()
  let s = raw.trim()
  if (!s) return ''

  if (!HTML_TAG_RE.test(s)) {
    return s.replace(/\s+/g, ' ').trim()
  }

  if (typeof document !== 'undefined') {
    const el = document.createElement('div')
    el.innerHTML = s
    return (el.textContent || '').replace(/\s+/g, ' ').trim()
  }

  s = s.replace(/<br\s*\/?>/gi, ' ')
  s = s.replace(/<\/p>\s*<p[^>]*>/gi, ' ')
  s = s.replace(/<[^>]+>/g, '')
  for (const [entity, ch] of Object.entries(ENTITY_MAP)) {
    s = s.split(entity).join(ch)
  }
  return s.replace(/\s+/g, ' ').trim()
}

/** Plain text safe for single-line fields (no newlines). */
export function toSingleLinePlainText(raw, maxLength) {
  const flat = stripHtmlToPlainText(raw).replace(/[\r\n]+/g, ' ').trim()
  if (!maxLength || maxLength <= 0) return flat
  const chars = [...flat]
  if (chars.length <= maxLength) return flat
  return chars.slice(0, maxLength).join('')
}
